import { TOPIC_COUNSELLOR } from 'mk/autogenerated/translations/CounsellingUserChip.3dcf4e3f0693289aa73b61c6de258c94'
import { CounsellingEntity } from 'mk2/apps/forum/schemas';
import { forumTopicUrl } from 'mk2/apps/forum/urls';
import AvatarImg from 'mk2/components/AvatarImg';
import Link from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './CounsellingUserChip.mscss';

interface OwnProps {
    counselling: CounsellingEntity;
}

export class CounsellingUserChip extends React.Component<OwnProps> {
    public render() {
        const {
            counselling,
        } = this.props;

        const counsellingTopicUrl = url(forumTopicUrl, { topicSlug: counselling.topic.slug });

        return (
            <Link
                className={styles.CounsellingUserChip}
                to={counsellingTopicUrl}
            >
                <AvatarImg
                    className={styles.CounsellingUserChip__avatar}
                    user={counselling.counsellor}
                    size={32}
                    counsellorAvatar={counselling.counsellorAvatar}
                />

                <div className={styles.CounsellingUserChip__info}>
                    <div className={styles.CounsellingUserChip__name}>
                        {counselling.counsellorName}
                    </div>
                    <div className={styles.CounsellingUserChip__badge}>
                        {TOPIC_COUNSELLOR}
                    </div>
                </div>
            </Link>
        );
    }
}
